"use client";

import { CheckCircle2 } from "lucide-react";

export function UserDoneStep() {
  return (
    <div className="space-y-6 py-4 text-center">
      <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-green-700">
        <CheckCircle2 className="h-8 w-8" />
      </div>
      <div className="space-y-2">
        <h3 className="text-lg font-semibold">You&apos;re all set</h3>
        <p className="text-sm text-muted-foreground">
          Your profile is ready. You can update it any time from the user menu
          under My Profile.
        </p>
      </div>
    </div>
  );
}
